import { getConfigValue } from '@jutro/config';
import appConfig from 'app-config';

/**
 * New capability to handle logout.  GW auth hub cannot handle logout like on-prem.  
 * When GW auth hub does revoke it has to redirect to a static url.  
 * The 'logout' page is a static view GW auth hub redirects to and it will handle 
 * redirection to our IdP.
 * 
 * US29415: [Technical UserStory] -PE /CE -Enable optional MFA (multi-factor authentication)
 * for Agents and policyholders
 * 
 * In the future this view could possibly be refactored to have App.js handle this.
 * https://stackoverflow.com/questions/47904283/react-router-redux-redirect-to-absolute-url
 * 
 * @param {*} props 
 * @returns 
 */
function LogoutPage(props) {

    localStorage.clear();
    sessionStorage.clear();

    // Clear the cache
    if ('caches' in window) {
        caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
        });
        });
    } 
    
    //Delete all cookies in a page
    document.cookie.split(";").forEach((c) => {
        document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });    

    const portalBaseUrl = getConfigValue('OKTA_REDIRECT_BASE', appConfig.authentication.servers.okta.JUTRO_AUTH_REDIRECT_BASE);
    const idpUrl = getConfigValue('CUSTOMER_IDP_LOGOUT_PATH', appConfig.authentication.customerIdpLogoutPath);
    const completeUrl = `${idpUrl}${portalBaseUrl}`;

    window.location.href = completeUrl;

    return null;
}

export default LogoutPage;